import { Script, graphql } from 'gatsby';
import React, { useEffect } from 'react';

type DisqusBlock = {
  _template?: string;
  css_class_name?: string;
  settings: any;
  src: string;
  timeout_duration?: number;
  append_to_head?: boolean;
  defer?: boolean;
  is_external?: boolean;
  on_script_load?: () => void;
};

const Disqus: React.FC<{ block: DisqusBlock; location: Location }> = ({
  block,
  location,
}) => {
  useEffect(() => {
    if (!window || !document) return;

    if (window.DISQUS) {
      window.DISQUS.reset({
        reload: true,
        config: function () {
          this.page.identifier = window.location.pathname;
          this.page.url = window.location.href;
          this.page.title = document.title;
        },
      });
    }
  }, [location.pathname]);

  return (
    <section className={`block ${block._template} ${block.css_class_name}`}>
      <div className='container--disqus container'>
        <div id='disqus_thread' />
      </div>
      {typeof window !== 'undefined' && !window.DISQUS && (
        <React.Fragment>
          <Script
            key={location.pathname} // ensures re-mount on URL change
            src={block.src}
            strategy='idle'
            data-timestamp={`${new Date()}`}
          />
        </React.Fragment>
      )}
    </section>
  );
};

export const DisqusQuery = graphql`
  fragment DisqusFragment on Block {
    src
    timeout_duration
    append_to_head
    defer
    is_external
  }
`;

export default Disqus;
